export default "__VITE_ASSET__f417b5ed__"